import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useConverterFeatures } from '../../hooks/useFeatureStatus';

interface Props {
  // 'web' needs Converter WEB. 'any' needs Converter WEB or Converter API.
  require: 'web' | 'any';
  children: React.ReactNode;
}

const ConverterFeatureGate: React.FC<Props> = ({ require, children }) => {
  const navigate = useNavigate();
  const { web, api, isLoading } = useConverterFeatures();
  const enabled = require === 'web' ? web : web || api;

  useEffect(() => {
    if (!isLoading && !enabled) {
      navigate('/', { replace: true, state: { openContact: 'converter' } });
    }
  }, [enabled, isLoading, navigate]);

  if (isLoading) {
    return <div className="text-center py-8 text-secondary">Loading...</div>;
  }

  if (!enabled) {
    return null;
  }

  return <>{children}</>;
};

export default ConverterFeatureGate;
